// Playful, padel-flavoured suffixes used to suggest an alternative team name
// when the requested one is already taken (e.g. "Oslo" -> "Oslo Aces").
// 50 per language. getTeamSuffixes() falls back to English for unknown codes.

export const teamSuffixes = {
  en: [
    'Aces', 'Smashers', 'Dinkers', 'Volleys', 'Lobsters', 'Bandits', 'Crew',
    'Squad', 'Legends', 'Rebels', 'Padelistas', 'Ninjas', 'Kings', 'Queens',
    'Warriors', 'Titans', 'Sharks', 'Eagles', 'Wolves', 'Dragons', 'Tigers',
    'Pandas', 'Flamingos', 'Rockets', 'Comets', 'Hurricanes', 'Thunder',
    'Lightning', 'Avengers', 'Misfits', 'Underdogs', 'Champions', 'All-Stars',
    'Hotshots', 'Mavericks', 'Gladiators', 'Vikings', 'Pirates', 'Outlaws',
    'Hustlers', 'Wall Huggers', 'Rally Rats', 'Net Busters', 'Drop Shots',
    'Baseliners', 'Spinners', 'Sliders', 'Dream Team', 'Smash Bros',
    'Court Kings',
  ],
  es: [
    'Ases', 'Pegadores', 'Dejadistas', 'Voleas', 'Langostas', 'Bandidos',
    'Banda', 'Escuadrón', 'Leyendas', 'Rebeldes', 'Padelistas', 'Ninjas',
    'Reyes', 'Reinas', 'Guerreros', 'Titanes', 'Tiburones', 'Águilas', 'Lobos',
    'Dragones', 'Tigres', 'Pandas', 'Flamencos', 'Cohetes', 'Cometas',
    'Huracanes', 'Truenos', 'Relámpagos', 'Vengadores', 'Inadaptados',
    'Aspirantes', 'Campeones', 'Estrellas', 'Cracks', 'Inconformistas',
    'Gladiadores', 'Vikingos', 'Piratas', 'Forajidos', 'Buscavidas',
    'Paredistas', 'Ratones de Pista', 'Rompe Redes', 'Globos', 'Fondistas',
    'Liftadores', 'Deslizadores', 'Equipo Soñado', 'Hermanos Smash',
    'Reyes de la Pista',
  ],
  no: [
    'Ess', 'Smashere', 'Stoppballer', 'Volleyer', 'Hummere', 'Banditter',
    'Gjengen', 'Troppen', 'Legender', 'Opprørere', 'Padelister', 'Ninjaer',
    'Konger', 'Dronninger', 'Krigere', 'Titaner', 'Haier', 'Ørner', 'Ulver',
    'Drager', 'Tigre', 'Pandaer', 'Flamingoer', 'Raketter', 'Kometer',
    'Orkaner', 'Torden', 'Lyn', 'Hevnere', 'Raringer', 'Outsidere', 'Mestere',
    'Stjerner', 'Kanoner', 'Villbasser', 'Gladiatorer', 'Vikinger', 'Pirater',
    'Lovløse', 'Luringer', 'Vegghengere', 'Banerotter', 'Nettknusere', 'Lobber',
    'Bakspillere', 'Skrumestere', 'Glidere', 'Drømmelaget', 'Smash-brødre',
    'Banekonger',
  ],
  sr: [
    'Asovi', 'Smečeri', 'Drop-šotovi', 'Voleji', 'Jastozi', 'Banditi', 'Ekipa',
    'Odred', 'Legende', 'Buntovnici', 'Padelisti', 'Nindže', 'Kraljevi',
    'Kraljice', 'Ratnici', 'Titani', 'Ajkule', 'Orlovi', 'Vukovi', 'Zmajevi',
    'Tigrovi', 'Pande', 'Flamingosi', 'Rakete', 'Komete', 'Uragani', 'Gromovi',
    'Munje', 'Osvetnici', 'Čudaci', 'Autsajderi', 'Šampioni', 'Zvezde',
    'Majstori', 'Divljaci', 'Gladijatori', 'Vikinzi', 'Pirati', 'Odmetnici',
    'Prevaranti', 'Zidari', 'Pacovi sa Terena', 'Razbijači Mreže', 'Lobovi',
    'Pozadinci', 'Spineri', 'Klizači', 'Tim Snova', 'Smeč Braća',
    'Kraljevi Terena',
  ],
  de: [
    'Asse', 'Schmetterer', 'Stoppbälle', 'Volleys', 'Hummer', 'Banditen',
    'Truppe', 'Mannschaft', 'Legenden', 'Rebellen', 'Padelisten', 'Ninjas',
    'Könige', 'Königinnen', 'Krieger', 'Titanen', 'Haie', 'Adler', 'Wölfe',
    'Drachen', 'Tiger', 'Pandas', 'Flamingos', 'Raketen', 'Kometen', 'Orkane',
    'Donner', 'Blitze', 'Rächer', 'Sonderlinge', 'Außenseiter', 'Meister',
    'Sterne', 'Kanonen', 'Draufgänger', 'Gladiatoren', 'Wikinger', 'Piraten',
    'Gesetzlose', 'Schlitzohren', 'Wandhocker', 'Feldratten', 'Netzbrecher',
    'Lobs', 'Grundlinienspieler', 'Spinner', 'Gleiter', 'Traumteam',
    'Schmetter-Brüder', 'Platzkönige',
  ],
  id: [
    'Jagoan', 'Pemukul', 'Bola Tipis', 'Voli', 'Lobster', 'Bandit', 'Geng',
    'Skuad', 'Legenda', 'Pemberontak', 'Padelista', 'Ninja', 'Raja', 'Ratu',
    'Ksatria', 'Titan', 'Hiu', 'Elang', 'Serigala', 'Naga', 'Harimau', 'Panda',
    'Flamingo', 'Roket', 'Komet', 'Badai', 'Guntur', 'Petir', 'Pembalas',
    'Si Aneh', 'Kuda Hitam', 'Juara', 'Bintang', 'Pemain Top', 'Si Liar',
    'Gladiator', 'Viking', 'Bajak Laut', 'Penjahat', 'Penipu Ulung',
    'Penjaga Dinding', 'Tikus Lapangan', 'Penghancur Net', 'Bola Lambung',
    'Pemain Belakang', 'Pemutar', 'Peluncur', 'Tim Impian', 'Smash Bros',
    'Raja Lapangan',
  ],
};

export const getTeamSuffixes = (lang) => teamSuffixes[lang] || teamSuffixes.en;
